import type { CmsPagePart } from "@/model/c-m-s/cms-page-part"

export function getHref(element: CmsPagePart) {
    if (!element.config.buttonLink && !(element.config.extLink || element.externalLink)) {
        console.warn("Invalid configuration for getHref(). Expected buttonLink / extLink", element)
        return null
    }

    if (element.config.buttonLink === "_ext") {
        return element.externalLink ? element.externalLink : element.config.extLink
    }

    return element.config.buttonLink
}

export function getTarget(element: CmsPagePart) {
    return element.config.target ? element.config.target : "_self"
}
